<template>
  <div class="ll-state-user-setting-card">
    <UserAvatarButton :image="image" />
    <ListCard
      is-table
      white
      no-padding
      class="mb-10"
    >
      <ListCardItem
        is-table
        :title="$t('姓名')"
        type="text"
        row
        :text-content="name"
      />
      <ListCardItem
        is-table
        :title="$t('信箱')"
        type="text"
        row
        :text-content="email"
      />
      <ListCardItem
        is-table
        :title="$t('密碼')"
        type="text-button"
        row
        text-content="•••••••••••••"
        :button-text="$t('變更密碼')"
        @click="$_changePasswordClick()"
      />
      <ListCardItem
        is-table
        :title="$t('語言')"
        type="dropdown"
        row
      >
        <template v-slot:dropdown>
          <DropdownMenuButton
            v-model="languageDropdownMenuItem.selectedMenuItem"
            :dropdown-menu-item="localeList"
            :placeholder="languageDropdownMenuItem.placeholder"
            outline
            @clicked-data="$_selectLocaleClick($event)"
          />
        </template>
      </ListCardItem>
    </ListCard>
    <WsButton001
      v-if="false"
      outLine
      widthStretch
      @click="$emit('click', 'agent')"
    >
      {{ $t('查看代理人列表') }}
    </WsButton001>
  </div>
</template>
<script>
export default {
  name: "LlStateUserSettingCard",
  props: {
    name: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    localeList: {
      type: Array,
      default() {
        return [];
      },
    },
    locale: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      languageDropdownMenuItem: {
        placeholder: this.$t("請選擇語言"),
        selectedMenuItem: "1",
        menuItems: [
          {
            id: "zh",
            textLabel: this.$t("繁體中文"),
          },
          {
            id: "cn",
            textLabel: this.$t("簡體中文"),
          },
          {
            id: "en",
            textLabel: this.$t("英文"),
          },
        ],
      },
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
  },
  watch: {
    locale() {
      this.languageDropdownMenuItem.selectedMenuItem = this.locale;
    },
  },
  mounted() {
    this.languageDropdownMenuItem.selectedMenuItem = this.locale;
  },
  methods: {
    $_changePasswordClick() {
      this.$emit("change-password");
    },
    $_selectLocaleClick($event) {
      this.$emit("select-locale", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-state-user-setting-card";
</style>